
import styles from "./styles.module.scss";

export default function LoadingPage() {
  return (
    <div className={styles.wrapper}>
    <div className={styles.spinnerBox}>
      <div className={styles.circleBorder}>
        <div className={styles.circleCore}></div>
      </div>
    </div>
    </div>
  );
}
